export default __webpack_public_path__ + "static/AA081210_Citation_680-0141-02a_540x358-300x198-9bc5345cb02be1f00c2763e67ecdbe76.jpg";